import * as yup from 'yup';
import { EmailTemplateType } from '../../enums/EmailTemplateType';

export interface IEmailTemplate {
  type: EmailTemplateType;
  text: string;
}

export const EmailTemplateSchema = yup.object({
  type: yup.mixed<EmailTemplateType>().oneOf(Object.values(EmailTemplateType)).required(),
  text: yup.string().required(),
});
